
<template>
  <v-container>
    <v-btn
      icon
      :to="`/tasklist/trainingDetail/${courseId}`"
      class="mb-2"
    >
      <v-icon>{{ mdiArrowLeft }}</v-icon>
    </v-btn>

    <v-layout row>
      <v-flex
        md10
        offset-md1
      >
        <v-card>
          <v-card-text>
            <div class="subheading">
              {{ $chPtObjData('chinTaskListTitle', activeItem) }}
            </div>
            <div class="grey--text">
              <span v-html="$chPtObjData('chinTaskListDesc1', activeItem)" /><br>
              {{ $chPtObjData('chinTaskListDesc2', activeItem) }}
            </div>
            <br>
          </v-card-text>

          <div class="primary--text px-3">
            {{ $t('Training.ApplyListOrder') }}
          </div>

          <!-- <v-fade-transition
            class="v-list--two-line"
            group
            tag="v-list"
          > -->
          <v-fade-transition
            class="v-list--three-line"
            group
          >
            <template v-for="(staff, index) in staffList">
              <div
                :key="staff.euid"
              >
                <v-list-item class="v-list__tile--light">
                  <v-list-item-content>
                    <v-list-item-title>{{ staff.staffChinName }}  {{ staff.staffPortName }}</v-list-item-title>
                    <v-list-item-subtitle>
                      <div class="grey--text">
                        {{ $t('TrainingClient.EnterCareerDate') }}：{{ momentWithHyphen(staff.enterCareerDate).format('YYYY-MM-DD') }}
                        <span v-if="staff.lastAppraiserEuid"><br> {{ $chPtObjData('lastAppraiserChinName', staff) }} {{ $t('TrainingClient.TaskList.Personal1.Agree') }}, {{ $t('TrainingClient.HistoryTaskList.Ordering') }}: {{ staff.appraiserOrder }} </span>
                      </div>
                      <div
                        v-if="staff.filledIPFormYears"
                        class="grey--text mb-3"
                      >
                        * {{ $t('Training.BelongTrainingNeed') }}：{{ staff.filledIPFormYears }} {{ $t('Training.YearPeriod') }}
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <div>
                      <v-btn
                        :disabled="index === 0"
                        icon
                        @click="moveUp(index)"
                      >
                        <v-icon color="primary">
                          {{ mdiArrowUp }}
                        </v-icon>
                      </v-btn>

                      <v-btn
                        :disabled="index === staffList.length - 1"
                        icon
                        class="ml-2"
                        @click="moveDown(index)"
                      >
                        <v-icon color="primary">
                          {{ mdiArrowDown }}
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="index !== staffList.length - 1" />
              </div>
            </template>
          </v-fade-transition>

          <v-card-text>
            <div class="primary--text">
              {{ $t('Training.SubmitTarget') }}
            </div>
            <v-radio-group
              v-model="isDirectToCoordinator"
              row
            >
              <v-radio
                :label="$t('TrainingClient.Superior')"
                value="0"
              />
              <v-radio
                :label="$t('Training.TrainingCoordinator')"
                value="1"
              />
            </v-radio-group>
            <v-flex
              xs12
              sm6
              d-flex
            >
              <s-search-staff
                v-if="isDirectToCoordinator==='0'"
                show-support-staff
                :select.sync="assignedToEuid"
                :label="$t('Training.SubmitTarget')"
                single-line
                hide-details
              />
            </v-flex>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="primary"
              class="ml-2"
              :loading="loading"
              @click="submitForm"
            >
              {{ $t('PublicServant.Action.Save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import VList from 'vuetify/lib'

import { momentWithHyphen } from '@/utils/datetimeUtil'
import SSearchStaff from '../../components/SSearchStaff'
import { mapState } from 'vuex'
// import { mapTaskListMultiRowFields } from '../../store/modules/training/taskList'
import taskListApi from '../../api/training/taskList'
import { breakSubErrors } from '../../utils/messageUtil'
import { globalModule, trainingTLModule, staffModule } from '../../store/moduleName'
import { mdiArrowLeft, mdiArrowUp, mdiArrowDown } from '@mdi/js'

export default {
  components: {
    // VList,
    SSearchStaff
  },
  props: {
    courseId: {
      type: String,
      required: true
    }
  },
  data: () => {
    return {
      mdiArrowDown: mdiArrowDown,
      mdiArrowUp: mdiArrowUp,
      mdiArrowLeft: mdiArrowLeft,
      loading: false,
      assignedToEuid: null,
      isDirectToCoordinator: null
    }
  },
  computed: {
    // ...mapTaskListMultiRowFields({
    //   staffList: 'finalItems'
    // }),
    ...mapState(trainingTLModule, {
      // finalItems: state => state[trainingTLModule].finalItems,
      // staffList: state => state.trainingTaskList.proposalClassActiveItems,
      staffList: state => state.acceptItems,
      rejectList: state => state.rejectItems,
      activeItem: state => state.classSummariesActiveItem
    })
  },
  watch: {
    isDirectToCoordinator (value) {
      if (value === '1') {
        this.assignedToEuid = null
      } else if (value === '0') {
        this.assignedToEuid = this.$store.state[staffModule].info.defaultNextEuid
      }
    }
  },
  created () {
    this.$store.dispatch(trainingTLModule + '/combineActiveAndHistoryItems')
  },
  methods: {
    moveUp: function (index) {
      this.$store.commit(trainingTLModule + '/reorderAcceptItems', { 'action': 'up', 'index': index })
      // this.staffList.splice((index - 1), 0, this.staffList.splice(index, 1)[0])
    },
    moveDown: function (index) {
      this.$store.commit(trainingTLModule + '/reorderAcceptItems', { 'action': 'down', 'index': index })
      // this.staffList.splice((index + 1), 0, this.staffList.splice(index, 1)[0])
    },
    submitForm: function () {
      let errorMessage = [{ chinMessage: '', portMessage: '' }]
      // this.$store.commit(trainingTLModule + '/setFinalItemsAssignedToEuid', this.assignedToEuid)
      this.$store.commit(trainingTLModule + '/setAcceptItemsAssignedToEuid', this.assignedToEuid)
      this.loading = true
      if (this.isDirectToCoordinator == null) {
        errorMessage[0].chinMessage = this.$t('TrainingClient.ChooseSubmitTarget', 'zh')
        errorMessage[0].portMessage = this.$t('TrainingClient.ChooseSubmitTarget', 'pt')
      }
      if (this.isDirectToCoordinator === '0' && this.assignedToEuid == null) {
        errorMessage[0].chinMessage = this.$t('TrainingClient.ChooseSubmitTarget', 'zh')
        errorMessage[0].portMessage = this.$t('TrainingClient.ChooseSubmitTarget', 'pt')
      }
      if (errorMessage[0].chinMessage.length > 0) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$chPtObjData('chinMessage', breakSubErrors(errorMessage)))
        this.loading = false
        return false
      }
      let finalList = JSON.parse(JSON.stringify(this.staffList)) // deep clone
      finalList = JSON.parse(JSON.stringify(finalList.concat(this.rejectList)))
      this.$store.commit(trainingTLModule + '/setFinalItemsByList', finalList)

      // console.log('finalItems: ' + JSON.stringify(this.$store.state[trainingTLModule].finalItems))
      // this.loading = false
      taskListApi.completeTrainingStep(cb => {
        if (cb.status === 201 || cb.status === 200) {
          // alert('successfully!')
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
          this.$router.push({ name: 'tasklist/trainingList' })
        }
        this.loading = false
      }, JSON.stringify(this.$store.state[trainingTLModule].finalItems))
    },
    momentWithHyphen: momentWithHyphen
  }
}

</script>
